<template>
  <div class="p-5 my-4">
    <div class="grid md:grid-cols-3">
      <div class="border-b pb-3 md:border-b-0 md:pb-0 md:border-r">
        <div class="mb-6 flex items-center justify-center text-xl font-bold gap-x-1">
          <span class="i-heroicons-chart-bar-solid" />
          <span>Total</span>
        </div>
        <div class="flex justify-around">
          <div class="text-slate-500 text-sm font-bold">
            Budget
          </div>
          <div>
            {{ currency(totalBudgetExpenses) }}
          </div>
        </div>
      </div>

      <div class="border-b py-3 md:border-b-0 md:py-0 md:border-r">
        <div class="mb-6 flex items-center justify-center text-xl font-bold gap-x-1">
          <span class="i-heroicons-cube" />
          <span>Materials</span>
        </div>
        <div class="flex justify-around">
          <div class="text-slate-500 text-sm font-bold">
            Budget
          </div>
          <div>
            {{ currency(materialsBudget) }}
          </div>
        </div>
      </div>

      <div class="pt-3 md:pt-0">
        <div class="mb-6 flex items-center justify-center text-xl font-bold gap-x-1">
          <span class="i-heroicons-clock-solid"  />
          <span>Labor</span>
        </div>
        <div class="flex justify-around">
          <div class="text-slate-500 text-sm font-bold">
            Budget
          </div>
          <div>
            {{ currency(laborsBudget) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { currency } from '@/utils'

defineProps({
  materialsBudget: {
    type: Number,
    default: 0
  },

  laborsBudget: {
    type: Number,
    default: 0
  },

  totalBudgetExpenses: {
    type: Number,
    default: 0
  },

  totalBudgetRevenue: {
    type: Number,
    default: 0
  }
})

// const calculateProfit = computed(() => {
//   return props.totalBudgetRevenue - props.totalBudgetExpenses
// })

// const calculateProfitMargin = computed(() => {
//   if (calculateProfit.value <= 0) return '0.00'
//   return ((calculateProfit.value / props.totalBudgetRevenue) * 100).toFixed(2)
// })

</script>
